import React from 'react';
import { ShieldCheck, Lock, FileText, CheckCircle2 } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="pt-24 bg-gray-950 min-h-screen text-left">
      <section className="py-16 bg-gradient-to-b from-gray-950 via-slate-900 to-gray-950 border-b border-gray-800">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <div className="inline-flex items-center space-x-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-1.5 mb-4">
            <Lock className="w-4 h-4 text-cyan-400" />
            <span className="text-cyan-400 text-sm font-semibold uppercase tracking-wider">
              Legal & Data Protection
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4">
            Privacy Policy
          </h1>
          <p className="text-gray-400 text-sm">
            Last Updated: January 2026 • Effective Date: January 1, 2026
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-950">
        <div className="container mx-auto px-6 max-w-4xl space-y-8 text-gray-300 text-sm leading-relaxed">
          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
              <ShieldCheck className="w-5 h-5 text-cyan-400" />
              1. Overview & Data Commitment
            </h2>
            <p>
              HOASP International ("we", "our", "us") respects your privacy and is committed to protecting the personal data of our website visitors, clients, and partners. This Privacy Policy outlines how we collect, use, store, and safeguard your information.
            </p>
          </div>

          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
              <FileText className="w-5 h-5 text-orange-400" />
              2. Information We Collect
            </h2>
            <ul className="space-y-2 mt-2">
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
                <span><strong>Contact Information:</strong> Name, work email address, phone number, and company name submitted via consultation forms.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
                <span><strong>Project Specification Data:</strong> Architecture preferences, RFP documents, and budget estimates shared during consultation.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
                <span><strong>Technical Analytics:</strong> IP address, browser type, device metadata, and site navigation patterns via privacy-preserving telemetry.</span>
              </li>
            </ul>
          </div>

          <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-white mb-3 flex items-center gap-2">
              <Lock className="w-5 h-5 text-amber-400" />
              3. Data Protection & Non-Disclosure (NDA)
            </h2>
            <p>
              We execute mutual Non-Disclosure Agreements (NDAs) prior to accepting proprietary client specifications. Your codebase, client data, and proprietary business logic remain 100% confidential and owned exclusively by your organization.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
